<button mat-stroked-button
        color="primary"
        [disabled]="disabled"
        [matTooltip]="'button.save' | translate"
        (click)="openSaveDialog()">
  <mat-icon class="icon-1-4-rem">save</mat-icon>
</button>
